//import services from './services.js';
import NProgress from 'nprogress';
import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import areaSelect from 'area-select';
import viewPhoto from 'src/common/js/viewPhoto';

export default {
    //mixins: [services],
    components: {
        areaSelect
    },
    props: {},
    computed: {
        SchoolPicsCtnId() {
            return 'SchoolPicsCtnId-' + new Date().getTime();
        },
        SchoolPicsBtnId() {
            return 'SchoolPicsBtnId-' + new Date().getTime();
        },
        LicencePicsCtnId() {
            return 'LicencePicsCtnId-' + new Date().getTime();
        },
        LicencePicsBtnId() {
            return 'LicencePicsBtnId-' + new Date().getTime();
        },
        CooperationPicsCtnId() {
            return 'CooperationPicsCtnId-' + new Date().getTime();
        },
        CooperationPicsBtnId() {
            return 'CooperationPicsBtnId-' + new Date().getTime();
        },
        EquipPicsCtnId() {
            return 'EquipPicsCtnId-' + new Date().getTime();
        },
        EquipPicsBtnId() {
            return 'EquipPicsBtnId-' + new Date().getTime();
        },
        ApplyPicsCtnId() {
            return 'ApplyPicsCtnId-' + new Date().getTime();
        },
        ApplyPicsBtnId() {
            return 'ApplyPicsBtnId-' + new Date().getTime();
        },
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    data() {
        return {
            up1: null,
            up2: null,
            up3: null,
            up4: null,
            btnLoading: false,
            checkedApplyPic: "",
            SubjectList: [], //项目类型
            isAdd: false,
            isUpdate: false,
            isReadonly: false,
            dialogVisible: false,
            dialogVisible2: false,
            dialogVisible3: false, //判断相似园弹窗
            DataList: [], //相似幼儿园列表
            SyncSchoolId: '',
            dialog2Message: "",
            d2Info: "",
            btnloading: false,
            agentVisible: true,
            isShowImg: true,
            isDefaultChecked: false,
            isApplyPicLisRequired: false, //判断平台开通申请表是否必填
            isChecked: [],
            address: this.initArea(),
            ProjectType: [], //项目类型
            Myshort: [],
            form: this.initFormData(),
            seldisabled: false,
            PolicyList: [],
            MyPolicy: [],
            PolicyType: [],
            applyPics: this.upDataApplyPic(), //新增平台申请表
            delPics: this.delApplyPic(), //删除平台申请表图片
            /*表单验证规则 */
            rules: {
                SchoolName: [{
                    required: true,
                    message: "请输入园所名称",
                    trigger: 'blur'
                }],
                PrincipalName: [{
                    required: true,
                    message: "请输入园长名称",
                    trigger: 'blur'
                }],
                Address: [{
                    required: true,
                    message: "请输入详细地址",
                    trigger: 'blur'
                }],
                AgentId: [{
                    required: true,
                    message: "请选择代理商"
                }],
                PhoneNo: [{
                    validator: util.elCheckPhone,
                    trigger: 'blur'
                }],
                // AddPhoneNo: [{
                //     validator: util.elCheckPhone,
                //     trigger: 'blur'
                // }]
            }
        }
    },
    methods: {
        initArea() {
            return cloneDeep({
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            });
        },
        upDataApplyPic() {
            return cloneDeep({
                "School_ApplyPicId": 0,
                "AgentId": 0,
                "ApplyPicList": []
            });
        },
        delApplyPic() {
            return cloneDeep({
                "School_ApplyPicId": 0,
                "PicUrl": "string"
            });
        },
        initFormData() {
            return cloneDeep({
                Id: "",
                AgentId: "",
                SchoolName: "",
                LongCode: "0.0",
                LatCode: "0.0",
                Address: "", //详细地址
                PhoneNo: "", //园长电话
                ProvId: "",
                CityId: "",
                AreaId: "",
                SchoolId: "",
                ProjectType: "",
                PolicyType: "",
                PrincipalName: "", //园长
                AddPhoneNo: "", //园所电话
                Email: "",
                QQ: "",
                DataType: 0,
                IsExperience: 0, //是否体验（新增）
                IsMerge: 0,
                School_ApplyPicId: "",
                ApplyPicList: [],
                CooperationPicsList: [],
                EquipPicsList: [],
                SchoolPicsList: [],
                LicencePicsList: [],
                Weixin: "", //微信
                ChildNum: "",
                Tuition: "",
                SchoolCome: '', //4为开课，5为会销添加的幼儿园 0为添加正式幼儿园
            });
        },
        changeProjectType(item) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: this.form.AgentId,
                AgentProjectType: item.join(",")
            }
            $http.get("api/School/GetPolicyTypeByAgentIdEx", params).then(res => {
                util.doResult(this, res, () => {
                    this.PolicyList = res.data.Data;
                    this.PolicyType = this.MyPolicy;
                    if (typeof callback == "function") {
                        callback();
                    }
                });

            });

            // if (item.indexOf(2) != -1) {

            // } else {
            //     this.MyPolicy = []
            //     this.PolicyList = []
            // }
        },
        show(options) {
            let opts = $.extend({}, {
                Id: "",
                AgentId: "",
                isAdd: false,
                isUpdate: false,
                isReadonly: false,
                SchoolCome: '',
                isShowImg: true,
                isDefaultChecked: false, //只有新增的添加幼儿园列表，平台申请表默认选中
            }, options);
            this.isApplyPicLisRequired = opts.isRequired
            this.isUpdate = opts.isUpdate;
            this.isAdd = opts.isAdd;
            this.isReadonly = opts.isReadonly;
            this.form.Id = opts.Id;
            this.form.School_ApplyPicId = opts.Id;

            this.form.SchoolCome = opts.SchoolCome;
            this.isShowImg = opts.isShowImg;
            this.isDefaultChecked = opts.isDefaultChecked
            if (opts.AgentId != "") {
                this.seldisabled = true;
                this.form.AgentId = opts.AgentId;
            }
            this.dialogVisible = true;
            if (this.isReadonly) {
                this.seldisabled = true;
                this.loadData(opts.Id);
                return;
            }
            this.getSchoolApplyPicById();
            this.req_getProjectType();
            this.initUploadfn();

        },
        loadData(Id, callback) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            let $msg = this.$message({
                message: '正在获取数据，请稍后...',
                duration: 0
            });

            $http.get("api/School/ZqwPlatform_GetSchoolModel", Params).then(res => {
                $msg.close();
                util.doResult(this, res, () => {
                    let {
                        Data
                    } = res.data;

                    this.form = cloneDeep($.extend({}, this.initFormData(), util.filterAndSetData(this.initFormData(), Data)));

                    this.address.Provinces_Id = Data.Provinces_id;
                    this.address.City_Id = Data.City_id;
                    this.address.Area_Id = Data.Area_id;
                    this.form.Id = Data.SchoolId;
                    this.form.AddPhoneNo = Data.Tel;

                    if (Data.ProjectTypes !== "") {
                        let a = Data.ProjectTypes.split(",");
                        for (var i = 0; i < a.length; i++) {
                            this.Myshort.push(parseInt(a[i]));
                        }
                    }

                    this.req_getProjectType();

                    if (typeof callback == "function") {
                        callback();
                    }
                });
            });
        },
        addFn(beforeCallback) {
            if (this.form.DataType == 0) {
                this.form.IsExperience = ''
            }
            if (typeof beforeCallback == "function") {
                beforeCallback();
            }
            let applyPic = [];
            $("input[name='gkkbo']:checked").each(function () {
                let $this = $(this);
                applyPic.push({
                    Name: $this.attr("serverName"),
                    Url: $this.attr("imgSrc")
                });
            });
            if (this.isApplyPicLisRequired) {
                if (applyPic.length == 0) {
                    this.$notify({
                        title: '警告',
                        message: "至少选择一个平台开通申请表",
                        type: 'warning'
                    });
                    return;
                }
            }
            let formData = cloneDeep(this.form);
            let address = this.$refs.area.validate();

            if (!!address) {

                formData.ApplyPicList = applyPic;
                formData.ProvId = address.Provinces_Id;
                formData.CityId = address.City_Id;
                formData.AreaId = address.Area_Id;
                formData.ProjectType = this.ProjectType.join(",");
                formData.PolicyType = this.PolicyType.join(",");
                if (this.SubjectList.length > 0) {
                    if ($.trim(formData.ProjectType).length == 0) {
                        this.$notify({
                            title: '警告',
                            message: "请选择项目类型",
                            type: 'warning'
                        });
                        return;
                    }
                }
                if (this.PolicyList.length > 0) {
                    if ($.trim(formData.PolicyType).length == 0) {
                        this.$notify({
                            title: '警告',
                            message: "请选择政策类型",
                            type: 'warning'
                        });
                        return;
                    }
                }
                // 园所电话可以是固话
                if (this.form.AddPhoneNo !== '') {
                    var res = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
                    if (!res.test(this.form.AddPhoneNo)) {
                        this.$notify({
                            title: '警告',
                            message: "园所电话:请输入正确电话号码格式",
                            type: 'warning'
                        });
                        return;
                    }

                } else if (this.form.AddPhoneNo == '') {
                    this.$notify({
                        title: '警告',
                        message: "请输入园所电话",
                        type: 'warning'
                    });
                    return;
                }
                //POST /api/School/OpenSchoolClassApply
                let params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession
                };
                this.btnloading = true;
                $http.post('api/School/OpenSchoolClassApply', Object.assign(params, formData)).then(res => {
                    this.btnloading = false;
                    util.doResult(this, res, () => {
                        let Data = $.extend({}, {
                            SchoolName: "",
                            IsMerge: 0
                        }, res.data.Data);
                        // 判断输入的园长电话是否为已存在的
                        if ($.trim(Data.IsMerge).indexOf("1") > -1) {
                            this.d2Info = Data.SchoolName;
                            this.dialogVisible2 = true;
                            return;
                        }
                        // 判断相似同省市幼儿园 IsMerge==2
                        if ($.trim(Data.IsMerge).indexOf("2") > -1) {
                            this.DataList = Data.SchoolList
                            this.dialogVisible3 = true;
                            return;
                        }
                        this.dialogVisible = false;
                        this.dialogVisible2 = false;
                        this.dialogVisible3 = false;
                        this.$emit('reloadList');
                        let Data2 = res.data.Data
                        Data2.AgentId = this.form.AgentId
                        if (this.form.SchoolCome == 4) {
                            this.$notify({
                                title: '成功',
                                message: '开课成功！',
                                type: 'success'
                            });
                            this.$router.push({
                                path: '/school/officialSchool'
                            });
                        } else {
                            this.$notify({
                                title: '成功',
                                message: '添加成功！',
                                type: 'success'
                            });
                            if (this.form.SchoolCome == 0) {
                                this.$router.push({
                                    path: '/school/officialSchool'
                                });
                            }
                            this.$emit('shcoolList', Data2);
                        }


                    });
                });
            }
        },
        closeCallback2() {

        },
        sureAgain() {
            this.form.IsMerge = 1;
            this.addFn();
        },
        cancel2() {
            this.form.IsMerge = 2;
            this.dialogVisible3 = false;
            this.addFn();
        },
        //相似幼儿园同步确定按钮
        sureAgain2() {
            this.form.IsMerge = 2;
            if (!this.form.SyncSchoolId) {
                this.$notify({
                    title: '警告',
                    message: '请选择一个幼儿园!',
                    type: 'warning'
                });
            } else {
                this.addFn();
            }

        },
        changeRadio(val) {
            this.form.SyncSchoolId = val
            for (let i = 0; i < this.DataList.length; i++) {
                if (val == this.DataList[i].Id) {
                    this.form.newSchoolName = this.DataList[i].SchoolName + '  ' + this.DataList[i].PrincipalName + '  ' + this.DataList[i].PrincipalPhoneNo
                }
            }
        },
        updateFn() {

        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        delC_Drawing(list, i) {
            list.splice(i, 1);
        },
        delC_Drawing2(list, i) {
            let item = list.splice(i, 1)
            if (this.form.Id !== "") {
                this.delPics.School_ApplyPicId = this.form.Id;
            };
            this.delPics.PicUrl = item[0].Url;
            $http.post('api/School/School_ApplyPicDel', this.delPics).then(res => {
                util.doResult(this, res, () => {
                    // this.$notify({
                    //     title: '成功',
                    //     message: '删除成功!',
                    //     type: 'success'
                    // });
                    this.getSchoolApplyPicById();
                });
            });

        },
        initUploadfn() {

            this.$nextTick(() => {

                this.up1 = util.initUploader(this, this.SchoolPicsCtnId, this.SchoolPicsBtnId, (file) => {
                    this.form.SchoolPicsList.push(file);
                });

                this.up2 = util.initUploader(this, this.LicencePicsCtnId, this.LicencePicsBtnId, (file) => {
                    this.form.LicencePicsList.push(file);
                });

                this.up3 = util.initUploader(this, this.CooperationPicsCtnId, this.CooperationPicsBtnId, (file) => {

                    this.form.CooperationPicsList.push(file);
                });

                this.up4 = util.initUploader(this, this.EquipPicsCtnId, this.EquipPicsBtnId, (file) => {
                    this.form.EquipPicsList.push(file);
                });

                this.up4 = util.initUploader(this, this.ApplyPicsCtnId, this.ApplyPicsBtnId, (file) => {

                    // 添加图片
                    if (this.form.Id !== "") {
                        this.applyPics.School_ApplyPicId = this.form.Id;
                    } else if (this.form.AgentId == "") {
                        this.$notify({
                            title: '警告',
                            message: '请先选择代理商!',
                            type: 'warning'
                        });
                        return;
                    } else {
                        this.applyPics.AgentId = this.form.AgentId
                        this.applyPics.School_ApplyPicId = 0
                    };
                    this.applyPics.ApplyPicList = [];
                    this.applyPics.ApplyPicList.push(file);
                    $http.post('api/School/School_ApplyPicAddEx', this.applyPics).then(res => {
                        util.doResult(this, res, () => {
                            if (res.data.Data !== null) {
                                this.form.Id = res.data.Data
                                this.form.School_ApplyPicId = this.form.Id
                            }
                            if (this.isDefaultChecked) {
                                this.isChecked.push(true)
                            }
                            this.getSchoolApplyPicById();
                        });
                    });
                });
            });

        },
        // 平台开通申请表添加
        getSchoolApplyPicById(callback) {
            if (this.form.Id !== "") {
                let params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    Id: this.form.Id
                };
                //GET /api/School/SchoolApplyPicById
                $http.get("api/School/SchoolApplyPicById", params).then(res => {
                    util.doResult(this, res, () => {
                        this.form.ApplyPicList = res.data.Data.ApplyPicList;
                        if (this.isDefaultChecked) {

                        }
                        if (typeof callback == "function") {
                            callback();
                        }
                    });
                });
            }
        },
        req_getProjectType(callback) {
            if (this.form.AgentId !== "") {
                let params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    AgentId: this.form.AgentId
                };
                //GET /api/School/SchoolApplyPicById
                $http.get("api/School/GetProjectByAgentId", params).then(res => {
                    util.doResult(this, res, () => {
                        this.SubjectList = res.data.Data;
                        this.ProjectType = this.Myshort;
                        if (typeof callback == "function") {
                            callback();
                        }
                    });
                });
            }
        },
        // goOpenSchoolClassApply() {
        //     let params = {
        //         Sid: this.$store.state.sysSid,
        //         Session: this.$store.state.sysSession
        //     };

        //     $http.post('api/School/OpenSchoolClassApply', params).then(res => {
        //         util.doResult(this, res, () => {
        //             this.$notify({
        //                 title: '成功',
        //                 message: '添加成功!',
        //                 type: 'success'
        //             });

        //             this.close();
        //         });
        //     });

        // },
        resetForm() {
            this.address = this.initArea();
            this.form = this.initFormData();
        },
        closeCallback() {
            this.resetForm();
            this.ProjectType = [];
            this.Myshort = [];
            this.SubjectList = [];
            this.PolicyList = [];
            this.MyPolicy = [];
            this.$refs.area.resetFields();

            if (this.up1) {
                this.up1.uploaderList[0].destroy();
            }

            if (this.up2) {
                this.up2.uploaderList[0].destroy();
            }

            if (this.up3) {
                this.up3.uploaderList[0].destroy();
            }

            if (this.up4) {
                this.up4.uploaderList[0].destroy();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {});
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/components/optOpenClassDialog/vm.js